<div class="page-container">
  <app-card>
    <div class="complete-state">
      @if (outcome() === 'success') {
        <app-icon name="circle-check-big" [size]="64" color="var(--bg-success)" />
        <h1>{{ 'signupComplete.success.title' | translate }}</h1>
        <p class="description">{{ 'signupComplete.success.description' | translate }}</p>
      } @else {
        <app-icon name="circle-alert" [size]="64" color="var(--fg-warning)" />
        <h1>{{ 'signupComplete.cancelled.title' | translate }}</h1>
        <p class="description">{{ 'signupComplete.cancelled.description' | translate }}</p>
      }

      <app-button variant="filled" (click)="continue()" data-testid="signup-complete-continue">
        {{ 'signupComplete.continue' | translate }}
      </app-button>
    </div>
  </app-card>
</div>
